export default {
  title: 'Minimum payment amount: Payments can’t be between {{rangeStart}} - {{rangeEnd}}',
  description: 'Exception: When you have a free item you can checkout with a total of {{amount}}.',
};
